module.exports = __webpack_public_path__ + "static/media/slide_2.88c9f62c.jpg";